import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdvanceSearchComponent } from './features/advance-search/advance-search.component';
import { HomeComponent } from './features/home/home.component';
import { AuthGuard, V6AdminAuthGuard, MarketingAdminAuthGuard, InvoiceInquiryAuthGuard, ManageCompanyAuthGuard, AccountSummaryAuthGuard, AdminMenuAuthGuard, SampleProductAdminAuthGuard } from './core/guards/auth.guard';
import { CartComponent } from './features/cart/cart.component';
import { ManageAttributeComponent } from './features/buildPak/admin/manage-attribute/manage-attribute.component';
import { CheckoutComponent } from './features/checkout/checkout.component';
import { BuildAndBuyComponent } from './features/build-and-buy/build-and-buy.component';
import { ProductCategoryComponent } from './features/build-and-buy/product-category/product-category.component';
import { ProductComponent } from './features/build-and-buy/product/product.component';
import { ProductConfigurationComponent } from './features/build-and-buy/product-configuration/product-configuration.component';
import { ManageQuoteComponent } from './features/order-management/manage-quote/manage-quote.component';
import { RequestQuoteComponent } from './features/order-management/manage-quote/request-quote/request-quote.component';
import { FactoryQuoteRequestComponent } from './features/order-management/manage-quote/factory-quote-request/factory-quote-request.component';
import { InvoiceInquiryComponent } from './features/order-management/invoice-inquiry/invoice-inquiry.component';
import { InHouseQuotesComponent } from './features/order-management/manage-quote/in-house-quotes/in-house-quotes.component';
import { KawneerdirectQuotesComponent } from './features/order-management/manage-quote/kawneerdirect-quotes/kawneerdirect-quotes.component';
import { InvoiceDetailComponent } from './features/order-management/invoice-inquiry/invoice-detail/invoice-detail.component';
import { OrderInquiryComponent } from './features/order-management/order-inquiry/order-inquiry.component';
import { OrderDetailComponent } from './features/order-management/order-inquiry/order-detail/order-detail.component';
import { QuoteDetailComponent } from './features/order-management/manage-quote/kawneerdirect-quotes/quote-detail/quote-detail.component';
import { ManageAddressComponent } from './features/checkout/customer-address/manage-address/manage-address.component';
import { ManageAccountComponent } from './features/manage-company/manage-account/manage-account.component';
import { ManageProductComponent } from './features/buildPak/admin/manage-product/manage-product.component';
import { AddNewProductComponent } from './features/buildPak/admin/manage-product/add-new-product/add-new-product.component';
import { CreditReferenceComponent } from './features/self-service-utilities/credit-reference/credit-reference.component';
import { SubmittalPackageComponent } from './features/self-service-utilities/submittal-package/submittal-package.component';
import { CustomerMultiplierPlanComponent } from './features/customer-multiplier/customer-multiplier-plan/customer-multiplier-plan.component';
import { CustomTermsConditionsNotesComponent } from './features/custom-terms-conditions-notes/custom-terms-conditions-notes.component';
import { NewUserComponent } from './features/new-user/new-user.component'
//import { SampleRequestComponent } from './features/self-service-utilities/sample-request/sample-request.component';
import { ConfigureProductComponent } from './features/buildPak/admin/manage-product/configure-product/configure-product.component';
import { CreateConfigurationComponent } from './features/buildPak/admin/manage-product/create-configuration/create-configuration.component';
import { AccountSummaryComponent } from './features/account-Summary/account-summary.component';
import { GenerateWarrantyComponent } from './features/self-service-utilities/generate-warranty/generate-warranty.component';
import { LienReleaseComponent } from './features/self-service-utilities/lien-release/lien-release.component';
import { LanguageTranslationComponent } from './features/buildPak/admin/kawneer-admin/language-translation/language-translation.component';
import { SubmittalPackageAdminComponent } from './features/buildPak/admin/marketing-admin/submittal-package-admin/submittal-package-admin.component';
import { UserAdminComponent } from './features/buildPak/admin/user-admin/user-admin.component';
import { SampleRequestAdminComponent } from './features/buildPak/admin/marketing-admin/sample-request-admin/sample-request-admin.component';
import { AdminBudgetReportComponent } from './features/buildPak/admin/marketing-admin/sample-request-admin/admin-budget-report/admin-budget-report.component';
import { ItemAdministrationComponent } from './features/buildPak/admin/kawneer-admin/item-administration/item-administration.component';
import { AddItemComponent } from './features/buildPak/admin/kawneer-admin/item-administration/add-item/add-item.component';
import { ManageMacroComponent } from './features/buildPak/admin/manage-macro/manage-macro.component';
import { AddNewMacroComponent } from './features/buildPak/admin/manage-macro/add-new-macro/add-new-macro.component';
import { EditNewMacroComponent } from './features/buildPak/admin/manage-macro/edit-new-macro/edit-new-macro.component';
import { BroadcastMessageAdminComponent } from './features/buildPak/admin/marketing-admin/broadcast-message-admin/broadcast-message-admin.component';
import { ErrorDashboardComponent } from './features/buildPak/admin/kawneer-admin/error-dashboard/error-dashboard.component';
import { HomescreenBannerAdminComponent } from './features/buildPak/admin/marketing-admin/homescreen-banner-admin/homescreen-banner-admin.component';
import { ProductConfigComponent } from './features/build-and-buy/product-config/product-config.component';
import { ConfigureNewProductComponent } from './features/build-and-buy/configure-new-product/configure-new-product.component';
import { CreateProductConfigurationComponent } from './features/build-and-buy/product-configuration/create-product-configuration/create-product-configuration.component';
import { ManageFrameComponent } from './features/buildPak/admin/manage-product/create-configuration/manage-frame/manage-frame.component';
import { ConfigureFrameComponent } from './features/buildPak/admin/manage-product/create-configuration/manage-frame/configure-frame/configure-frame.component';
import { SampleRequestNewComponent } from './features/self-service-utilities/sample-request/sample-request-new.component';
import { PromoCodeComponent } from './features/buildPak/admin/marketing-admin/promo-code/promo-code.component';
import { OutageScheduleComponent } from './features/buildPak/admin/marketing-admin/outage-schedule/outage-schedule.component';
import { ImagesAdminComponent } from './features/buildPak/admin/marketing-admin/images-admin/images-admin.component';
import { FaqComponent } from './features/faq/faq.component';
import { BuildConfiguredProductComponent } from './features/build-and-buy/build-configured-product/build-configured-product.component';
import { BuildKwikkeyProductComponent } from './features/build-and-buy/build-kwikkey-product/build-kwikkey-product.component';
import { EditConfiguredProductComponent } from './features/build-and-buy/edit-configured-product/edit-configured-product.component';
import { CopyConfiguredProductComponent } from './features/build-and-buy/copy-configured-product/copy-configured-product.component';
import { WindowPricingComponent } from './features/self-service-utilities/window-pricing/window-pricing.component';
import { ThermalCalculatorComponent } from './features/self-service-utilities/thermal-calculator/thermal-calculator.component';
import { CustomerSpecificSchoolAdminComponent } from './features/buildPak/admin/marketing-admin/customer-specific-school-admin/customer-specific-school-admin.component';
import { MechanicsSchoolAdminComponent } from './features/buildPak/admin/marketing-admin/mechanics-school-admin/mechanics-school-admin.component';
import { CustomerSpecificSchoolComponent } from './features/school-and-training/training/customer-specific-school/customer-specific-school.component';
import { MechanicsSchoolComponent } from './features/school-and-training/training/mechanics-school/mechanics-school.component';
import { ModulesSchoolAdminComponent } from './features/buildPak/admin/marketing-admin/modules-school-admin/modules-school-admin.component';
import { PartnerPakTrainingAdminComponent } from './features/buildPak/admin/marketing-admin/partner-pak-training-admin/partner-pak-training-admin.component';
import { PreInstallationSystemAdminComponent } from './features/buildPak/admin/marketing-admin/pre-installation-system-admin/pre-installation-system-admin.component';
import { ModulesSchoolComponent } from './features/school-and-training/training/modules-school/modules-school.component';
import { PartnerPakTrainingComponent } from './features/school-and-training/training/partner-pak-training/partner-pak-training.component';
import { PreInstallationSystemReviewComponent } from './features/school-and-training/training/pre-installation-system-review/pre-installation-system-review.component';
import { DetailsScreenComponent } from './features/literature/details-screen/details-screen.component';
import { LieraturePagesComponent } from './features/literature/lierature-pages/lierature-pages.component';
import { TermsAndConditionsComponent } from './features/footer-pages/terms-and-conditions/terms-and-conditions.component';
import { ContactUsComponent } from './features/footer-pages/contact-us/contact-us.component';
import { LegalNoticesComponent } from './features/footer-pages/legal-notices/legal-notices.component';
import { SurveyAdminComponent } from './features/buildPak/admin/marketing-admin/survey-admin/survey-admin.component';
import { SurveyComponent } from './features/survey/survey.component';
import { UnauthorizedComponent } from './features/unauthorized/unauthorized.component';
import { ErrorComponent } from './features/error/error.component';
import { ManageTranslationComponent } from './features/buildPak/admin/manage-translation/manage-translation.component';
import { AddTranslationComponent } from './features/buildPak/admin/manage-translation/add-translation/add-translation.component';
import { EditTranslationComponent } from './features/buildPak/admin/manage-translation/edit-translation/edit-translation.component';
import { EditValueTranslationComponent } from './features/buildPak/admin/manage-translation/edit-value-translation/edit-value-translation.component';
import { AddValueTranslationComponent } from './features/buildPak/admin/manage-translation/add-value-translation/add-value-translation.component';
import { ProductSetupComponent } from './features/buildPak/admin/product-setup/product-setup.component';
import { NewsAdminComponent } from './features/buildPak/admin/marketing-admin/news-admin/news-admin.component';
import { OutageComponent } from './features/outage/outage.component';
import { ReviewComponent } from './features/order-management/invoice-inquiry/payment/review/review.component';
import { PaymentCreditCardComponent } from './features/order-management/invoice-inquiry/payment/payment-credit-card/payment-credit-card.component';
import { PaymentCreditcardCompleteComponent } from './features/order-management/invoice-inquiry/payment/payment-creditcard-complete/payment-creditcard-complete.component';
import { PaymentCompleteComponent } from './features/order-management/invoice-inquiry/payment/payment-complete/payment-complete.component';
import { AchPaymentReconcilationComponent } from './features/buildPak/admin/payment-admin/ach-payment-reconcilation/ach-payment-reconcilation.component';
import { ClaimHistoryComponent } from './features/self-service-utilities/freight-claim/claim-history/claim-history.component';
import { OrderSelectionComponent } from './features/self-service-utilities/freight-claim/order-selection/order-selection.component';
import { RaiseClaimComponent } from './features/self-service-utilities/freight-claim/raise-claim/raise-claim.component';
import { ReviewOpenClaimComponent } from './features/buildPak/admin/freight-claim-admin/review-open-claim/review-open-claim.component';
import { ViewClaimHistoryComponent } from './features/buildPak/admin/freight-claim-admin/view-claim-history/view-claim-history.component';
import { ReviewClaimDetailsComponent } from './features/buildPak/admin/freight-claim-admin/review-claim-details/review-claim-details.component';
import { ReviewOpenClaimDetailsComponent } from './features/buildPak/admin/freight-claim-admin/review-open-claim-details/review-open-claim-details.component';
import { ReviewCompletedClaimDetailsComponent } from './features/buildPak/admin/freight-claim-admin/review-completed-claim-details/review-completed-claim-details.component';
import { ViewClaimDetailsComponent } from './features/self-service-utilities/freight-claim/view-claim-details/view-claim-details.component';
import { SampleRequestOrderHistoryComponent } from './features/buildPak/admin/marketing-admin/sample-request-order-history/sample-request-order-history.component';
import { SampleRequestOrderDetailsComponent } from './features/buildPak/admin/marketing-admin/sample-request-order-details/sample-request-order-details.component';
import { SampleRequestInventoryUsageReportComponent } from './features/buildPak/admin/marketing-admin/sample-request-inventory-usage-report/sample-request-inventory-usage-report.component';
import { HomeComponent as D1 } from './features/discount-store/home/home.component';
import { HomeComponent as ManageClearanceStoreComponent } from './features/discount-store/admin/home/home.component';
import { OrderHistoryComponent as DiscountOrderHistoryComponent } from './features/discount-store/admin/home/order-history/order-history.component';
import { OrderDetailsComponent as DiscountOrderDetailsComponent } from './features/discount-store/admin/home/order-history/order-details/order-details.component';
import { ReviewOpenOrdersComponent as DiscountStoreOpenOrders } from './features/discount-store/admin/review-open-orders/review-open-orders.component';
import { ImportDiscountStoreItemComponent } from './features/discount-store/admin/import-discount-store-item/import-discount-store-item.component';
import { CartCheckoutCreditCardPaymentCompleteComponent } from './features/checkout/cart-checkout-credit-card-payment-complete/cart-checkout-credit-card-payment-complete.component';
import { ExpressCheckoutCardPaymentCompleteComponent } from './features/order-management/manage-quote/kawneerdirect-quotes/quote-detail/express-checkout-card-payment-complete/express-checkout-card-payment-complete.component';
import { OrderFeesComponent } from './features/buildPak/admin/kawneer-admin/order-fees/order-fees.component';


const routes: Routes = [
  // Site routes goes here
  {
    path: 'home',
    component: HomeComponent,
    data: { breadcrumb: 'no-bread-crumb' },
  },
  {
    path: 'overstock',
    component: D1,
    data: { breadcrumb: 'no-bread-crumb' },
  }, 
  {
    path: 'discount-store/admin/import-item',
    component: ImportDiscountStoreItemComponent,
    data: { breadcrumb: 'no-bread-crumb' },
  },
  {
    path: 'discount-store/admin/order-history',
    component: DiscountOrderHistoryComponent,
    data: { breadcrumb: 'no-bread-crumb' },
  },
  {
    path: 'discount-store/admin/order-history/order-details/:orderId',
    component: DiscountOrderDetailsComponent,
    data: { breadcrumb: 'no-bread-crumb' },
  },
  {
    path: 'faq',
    component: FaqComponent,
    data: { breadcrumb: 'Faq' },
  },
  {
    path: 'terms-and-conditions',
    component: TermsAndConditionsComponent,
    data: { breadcrumb: 'Terms And Conditions' },
  },
  {
    path: 'contact-us',
    component: ContactUsComponent,
    data: { breadcrumb: 'Contact Us' },
  },
  {
    path: 'legal-notices',
    component: LegalNoticesComponent,
    data: { breadcrumb: 'Legal Notices' },
  },
  {
    path: 'survey',
    component: SurveyComponent,
    data: { breadcrumb: 'Survey' },
  },
  {
    path: 'advanced-search',
    component: AdvanceSearchComponent,
    canActivate: [AuthGuard],
    data: { breadcrumb: 'Advanced Search' },
  },
  {
    path: 'customer-multiplier-plan',
    component: CustomerMultiplierPlanComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Customer Multiplier Plan'
    }
  },
  {
    path: 'new-user',
    component: NewUserComponent,
    data: {
      breadcrumb: 'New User'
    }
  },
  {
    path: 'account-summary',
    component: AccountSummaryComponent,
    canActivate: [AccountSummaryAuthGuard],
    data: {
      breadcrumb: 'Account Summary'
    }
  },
  // otherwise redirect to home
  {
    path: '',
    redirectTo: 'home',
    data: { breadcrumb: 'no-bread-crumb' },
    pathMatch: 'full',
  },
  /*CART*/
  {
    path: 'cart',
    canActivate: [AuthGuard],
    data: { breadcrumb: 'Cart' },
    children: [
      {
        path: '',
        component: CartComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: 'no-bread-crumb' }
      },
      {
        path: 'checkout',
        component: CheckoutComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: 'Checkout' }
      },
      {
        path: 'checkout/order-complete',//:trackerID',//required
        component: CartCheckoutCreditCardPaymentCompleteComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: 'Checkout Complete' }
      },
      { path: 'editConfiguredProduct/:cartItemCommonId', component: EditConfiguredProductComponent, canActivate: [AuthGuard], data: { breadcrumb: 'EditConfiguredProduct' } },
      { path: 'copyConfiguredProduct/:cartItemCommonId', component: CopyConfiguredProductComponent, canActivate: [AuthGuard], data: { breadcrumb: 'CopyConfiguredProduct' } },
    ]
  },


  /*BuildPak*/
  {
    path: 'manageAttribute',
    canActivate: [AuthGuard, V6AdminAuthGuard],
    data: { breadcrumb: 'Manage Attribute' },
    children: [
      {
        path: '',
        component: ManageAttributeComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: 'no-bread-crumb' },
      }
    ]
  },
  {
    path: 'manageProduct',
    canActivate: [V6AdminAuthGuard],
    data: { breadcrumb: 'no-bread-crumb' },
    children: [
      {
        path: '', canActivate: [V6AdminAuthGuard], data: { breadcrumb: 'Manage Product' },
        children: [
          { path: '', component: ManageProductComponent, canActivate: [V6AdminAuthGuard], data: { breadcrumb: 'no-bread-crumb' } },
          { path: 'add-new-product', component: AddNewProductComponent, canActivate: [V6AdminAuthGuard], data: { breadcrumb: 'Add New Product' } },
        ]
      },
    ]
  },
  {
    path: 'manageMacro',
    canActivate: [V6AdminAuthGuard],
    data: { breadcrumb: 'no-bread-crumb' },
    children: [
      {
        path: '', canActivate: [V6AdminAuthGuard], data: { breadcrumb: 'Manage Macro' },
        children: [
          { path: '', component: ManageMacroComponent, canActivate: [AuthGuard], data: { breadcrumb: 'no-bread-crumb' } },
          { path: 'add-new-macro', component: AddNewMacroComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Add New Macro' } },
          { path: 'edit-macro', component: EditNewMacroComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Edit New Macro' } },
        ]
      },
    ]
  },
  {
    path: 'configProduct',
    //canActivate: [AuthGuard, INTuserV6AdminAuthGuard],
    data: { breadcrumb: 'no-bread-crumb' },
    children: [
      {
        path: '', canActivate: [V6AdminAuthGuard], data: { breadcrumb: 'Configure Product' },
        children: [
          { path: '', component: CreateConfigurationComponent, canActivate: [V6AdminAuthGuard], data: { breadcrumb: 'no-bread-crumb' } },
          { path: 'buildConfiguredProduct', component: BuildConfiguredProductComponent, canActivate: [V6AdminAuthGuard], data: { breadcrumb: 'BuildConfiguredProduct' } },
          { path: 'buildKwikkeyProduct', component: BuildKwikkeyProductComponent, canActivate: [V6AdminAuthGuard], data: { breadcrumb: 'BuildKwikkeyProduct' } },
          //{ path: 'editConfiguredProduct/:cartItemCommonId', component: EditConfiguredProductComponent, canActivate: [AuthGuard], data: { breadcrumb: 'EditConfiguredProduct' } },
          //{ path: 'copyConfiguredProduct/:cartItemCommonId', component: CopyConfiguredProductComponent, canActivate: [AuthGuard], data: { breadcrumb: 'CopyConfiguredProduct' } },
          {
            path: 'createConfiguration', canActivate: [V6AdminAuthGuard],
            data: { breadcrumb: 'CreateConfiguration' }, children: [
              { path: '', component: CreateConfigurationComponent, canActivate: [V6AdminAuthGuard], data: { breadcrumb: 'no-bread-crumb' } },
              { path: 'manageFrame', component: ManageFrameComponent, canActivate: [V6AdminAuthGuard], data: { breadcrumb: 'ManageFrame' } },
              { path: 'configureFrame', component: ConfigureFrameComponent, canActivate: [V6AdminAuthGuard], data: { breadcrumb: 'Configure Frame' } },
            ]
          },
          {
            path: 'configure', component: ConfigureProductComponent, canActivate: [V6AdminAuthGuard],
            data: { breadcrumb: 'no-bread-crumb' }
          }, {
            path: 'productConfiguration', component: ProductConfigurationComponent, canActivate: [V6AdminAuthGuard],
            data: { breadcrumb: 'ProductConfiguration' }
          }, {
            path: 'createProductConfiguration', canActivate: [V6AdminAuthGuard],
            data: { breadcrumb: 'CreateProductConfiguration' }, children: [
              { path: '', component: ConfigureProductComponent, canActivate: [V6AdminAuthGuard], data: { breadcrumb: 'no-bread-crumb' } },
            ]
          }
        ]
      },
    ]
  },
  {
    path: 'manageTranslation',
    canActivate: [V6AdminAuthGuard],
    data: { breadcrumb: 'no-bread-crumb' },
    children: [
      {
        path: '', canActivate: [V6AdminAuthGuard], data: { breadcrumb: 'Manage Translation' },
        children: [
          { path: '', component: ManageTranslationComponent, canActivate: [V6AdminAuthGuard], data: { breadcrumb: 'no-bread-crumb' } },
          { path: 'add-translation', component: AddTranslationComponent, canActivate: [V6AdminAuthGuard], data: { breadcrumb: 'Add Translation' } },
          { path: 'add-value-translation', component: AddValueTranslationComponent, canActivate: [V6AdminAuthGuard], data: { breadcrumb: 'Add Value Translation' } },
          { path: 'edit-translation', component: EditTranslationComponent, canActivate: [V6AdminAuthGuard], data: { breadcrumb: 'Edit Translation' } },
          { path: 'edit-value-translation', component: EditValueTranslationComponent, canActivate: [V6AdminAuthGuard], data: { breadcrumb: 'Edit Value Translation' } }
        ]
      },
    ]
  },
  {
    path: 'product-setup',
    canActivate: [V6AdminAuthGuard],
    data: { breadcrumb: 'no-bread-crumb' },
    children: [
      {
        path: '', canActivate: [V6AdminAuthGuard], data: { breadcrumb: 'Product Setup' },
        children: [
          { path: '', component: ProductSetupComponent, canActivate: [V6AdminAuthGuard], data: { breadcrumb: 'no-bread-crumb' } }

        ]
      },
    ]
  },
  {
    path: 'languageTranslation',
    canActivate: [AdminMenuAuthGuard],
    data: { breadcrumb: 'Language Translation' },
    children: [
      {
        path: '',
        component: LanguageTranslationComponent,
        canActivate: [AdminMenuAuthGuard],
        data: { breadcrumb: 'no-bread-crumb' },
      }
    ]
  },
  {
    path: 'orderFees',
    canActivate: [AdminMenuAuthGuard],
    data: { breadcrumb: 'Order Fees' },
    children: [
      {
        path: '',
        component: OrderFeesComponent,
        canActivate: [AdminMenuAuthGuard],
        data: { breadcrumb: 'no-bread-crumb' },
      }
    ]
  },
  {
    path: 'itemAdministration',
    canActivate: [AdminMenuAuthGuard],
    data: { breadcrumb: 'itemAdministration' },
    children: [
      {
        path: '',
        component: ItemAdministrationComponent,
        canActivate: [AdminMenuAuthGuard],
        data: { breadcrumb: 'no-bread-crumb' },
      },
      {
        path: 'addItem',
        component: AddItemComponent,
        canActivate: [AdminMenuAuthGuard],
        data: { breadcrumb: 'Add Item' },
      }
    ]
  },
  {
    path: 'submittal-package-admin',
    canActivate: [MarketingAdminAuthGuard],
    data: { breadcrumb: 'Submittal Package Admin' },
    children: [
      {
        path: '',
        component: SubmittalPackageAdminComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: 'no-bread-crumb' },
      }
    ]
  },



  {
    path: 'ach-payment-recon',
    canActivate: [AdminMenuAuthGuard],
    data: { breadcrumb: 'Payment Recon' },
    children: [
      {
        path: '',
        component: AchPaymentReconcilationComponent,
        canActivate: [AdminMenuAuthGuard],
        data: { breadcrumb: 'no-bread-crumb' },
      }
    ]
  },



  {
    path: 'user-admin',
    canActivate: [AdminMenuAuthGuard],
    data: { breadcrumb: 'User Admin' },
    children: [
      {
        path: '',
        component: UserAdminComponent,
        canActivate: [AdminMenuAuthGuard],
        data: { breadcrumb: 'no-bread-crumb' },
      }
    ]
  },
  //#region Sample Product
  {
    path: 'sample-request-admin',
    canActivate: [SampleProductAdminAuthGuard],
    data: { breadcrumb: 'Sample Request Admin' },
    children: [
      {
        path: '',
        component: SampleRequestAdminComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: 'no-bread-crumb' },
      },
      {
        canActivate: [SampleProductAdminAuthGuard],
        path: 'admin-budget-report',
        component: AdminBudgetReportComponent,
        data: { breadcrumb: 'Budget/Allocation Reports' },
      },
      {
        path: 'sample-request-order-history',
        canActivate: [SampleProductAdminAuthGuard],
        component: SampleRequestOrderHistoryComponent,
        data: { breadcrumb: 'Order History' }
      },
      {
        path: 'sample-request-order-history2/order-details/:orderId',
        canActivate: [SampleProductAdminAuthGuard],
        component: SampleRequestOrderDetailsComponent,
        data: { breadcrumb: ['Order Details'] },
      },

      {
        path: 'sample-request-inventory-usage-report',
        canActivate: [SampleProductAdminAuthGuard],
        component: SampleRequestInventoryUsageReportComponent,
        data: { breadcrumb: 'Inventory/Usage Report' }
      }
    ]
  },
  //#endregion
  //#region Discount Store admin ** fix this
  //{
  //  path: 'review-open-clearance-store-orders',
  //  canActivate: [AuthGuard],
  //  data: { breadcrumb: 'Review Clearance Store Order' },
  //  children: [
  //    { path: '', component: DiscountStoreOpenOrders, canActivate: [AuthGuard], data: { breadcrumb: 'no-bread-crumb' } },
  //  ]
  //},

  {
    path: 'review-open-clearance-store-orders',
    canActivate: [AuthGuard],
    data: { breadcrumb: 'Review Open Orders' },
    children: [
      {
        path: '', component: DiscountOrderHistoryComponent,
        canActivate: [AuthGuard], data: { breadcrumb: 'no-bread-crumb' }
      },
      {
        canActivate: [AuthGuard],
        path: 'view-order-details/:orderNo',
        component: DiscountOrderDetailsComponent,
        data: { breadcrumb: 'Order Detail' }
      },
    ]
  },
  {
    path: 'view-clearance-store-order-history',
    canActivate: [AuthGuard],
    data: { breadcrumb: 'Order History' },
    children: [
      {
        path: '', component: DiscountOrderHistoryComponent,
        canActivate: [AuthGuard], data: { breadcrumb: 'no-bread-crumb' }
      },
      {
        canActivate: [AuthGuard],
        path: 'view-order-details/:orderNo',
        component: DiscountOrderDetailsComponent,
        data: { breadcrumb: 'Order Detail' }
      },
    ]
  },
  {
    path: 'manage-clearance-store',
    canActivate: [AuthGuard],
    data: { breadcrumb: 'Manage Overstock Store' },
    children: [
      {
        path: '', component: ManageClearanceStoreComponent,
        canActivate: [AuthGuard], data: { breadcrumb: 'no-bread-crumb' }
      },
      {
        canActivate: [AuthGuard],
        path: 'import-items',
        component: ImportDiscountStoreItemComponent,
        data: { breadcrumb: 'Import Items' }
      },
    ]
  },

  //#endregion

  {
    path: 'broadcast-message-admin',
    canActivate: [MarketingAdminAuthGuard],
    data: { breadcrumb: 'Broadcast Message Admin' },
    children: [
      {
        path: '',
        component: BroadcastMessageAdminComponent,
        canActivate: [MarketingAdminAuthGuard],
        data: { breadcrumb: 'no-bread-crumb' },
      }
    ]
  },
  {
    path: 'promo-code',
    canActivate: [MarketingAdminAuthGuard],
    data: { breadcrumb: 'Promo Code' },
    children: [
      {
        path: '',
        component: PromoCodeComponent,
        canActivate: [MarketingAdminAuthGuard],
        data: { breadcrumb: 'no-bread-crumb' },
      }
    ]
  },
  {
    path: 'outage-schedule',
    canActivate: [MarketingAdminAuthGuard],
    data: { breadcrumb: 'Outage Schedule' },
    children: [
      {
        path: '',
        component: OutageScheduleComponent,
        canActivate: [MarketingAdminAuthGuard],
        data: { breadcrumb: 'no-bread-crumb' },
      }
    ]
  },
  {
    path: 'error-dashboard',
    canActivate: [AdminMenuAuthGuard],
    data: { breadcrumb: 'Error Dashboard' },
    children: [
      {
        path: '',
        component: ErrorDashboardComponent,
        canActivate: [AdminMenuAuthGuard],
        data: { breadcrumb: 'no-bread-crumb' },
      }
    ]
  },
  {
    path: 'homescreen-banner-admin',
    canActivate: [MarketingAdminAuthGuard],
    data: { breadcrumb: 'HomeScreen Banner Admin' },
    children: [
      {
        path: '',
        component: HomescreenBannerAdminComponent,
        canActivate: [MarketingAdminAuthGuard],
        data: { breadcrumb: 'no-bread-crumb' },
      }
    ]
  },
  {
    path: 'images-admin',
    canActivate: [MarketingAdminAuthGuard],
    data: { breadcrumb: 'Image Master' },
    children: [
      {
        path: '',
        component: ImagesAdminComponent,
        canActivate: [MarketingAdminAuthGuard],
        data: { breadcrumb: 'no-bread-crumb' },
      }
    ]
  },
  {
    path: 'customer-specific-school-admin',
    canActivate: [AuthGuard],
    data: { breadcrumb: 'Customer Specific School Admin' },
    children: [
      {
        path: '',
        component: CustomerSpecificSchoolAdminComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: 'no-bread-crumb' },
      }
    ]
  },
  {
    path: 'mechanics-school-admin',
    canActivate: [AuthGuard],
    data: { breadcrumb: 'Mechanics School Admin' },
    children: [
      {
        path: '',
        component: MechanicsSchoolAdminComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: 'no-bread-crumb' },
      }
    ]
  },
  {
    path: 'modules-school-admin',
    canActivate: [AuthGuard],
    data: { breadcrumb: 'Modules School Admin' },
    children: [
      {
        path: '',
        component: ModulesSchoolAdminComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: 'no-bread-crumb' },
      }
    ]
  },
  {
    path: 'partner-pak-training-admin',
    canActivate: [AuthGuard],
    data: { breadcrumb: 'Partner Pak Training Admin' },
    children: [
      {
        path: '',
        component: PartnerPakTrainingAdminComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: 'no-bread-crumb' },
      }
    ]
  },
  {
    path: 'pre-installation-system-review-admin',
    canActivate: [AuthGuard],
    data: { breadcrumb: 'Pre Installation System Review Admin' },
    children: [
      {
        path: '',
        component: PreInstallationSystemAdminComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: 'no-bread-crumb' },
      }
    ]
  },
  {
    path: 'survey-admin',
    canActivate: [AuthGuard],
    data: { breadcrumb: 'Survey Admin' },
    children: [
      {
        path: '',
        component: SurveyAdminComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: 'no-bread-crumb' },
      }
    ]
  },
  {
    path: 'survey',
    canActivate: [AuthGuard],
    data: { breadcrumb: 'Survey' },
    children: [
      {
        path: '',
        component: SurveyComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: 'no-bread-crumb' },
      }
    ]
  },
  {
    path: 'news-admin',
    canActivate: [AuthGuard],
    data: { breadcrumb: 'News Admin' },
    children: [
      {
        path: '',
        component: NewsAdminComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: 'no-bread-crumb' },
      }
    ]
  },
  //** Claims Admin
  {
    path: 'review-open-claims',
    canActivate: [AuthGuard],
    data: { breadcrumb: 'Review Open Claims' },
    children: [
      { path: '', component: ReviewOpenClaimComponent, canActivate: [AuthGuard], data: { breadcrumb: 'no-bread-crumb' } },
      {
        canActivate: [AuthGuard],
        path: 'edit-open-claim/:claimId',
        component: ReviewOpenClaimDetailsComponent,
        data: { breadcrumb: 'Update Claim' }
      },
    ]
    //children: [
    //  {
    //    path: '',
    //    component: ReviewOpenClaimComponent,
    //    canActivate: [AuthGuard],
    //    data: { breadcrumb: 'no-bread-crumb' },
    //  }
    //]
  },
  //{
  //  path: 'review-claim-details',
  //  canActivate: [AuthGuard],
  //  data: { breadcrumb: 'Review Claim' },
  //  children: [
  //    {
  //      path: '',
  //      component: ReviewClaimDetailsComponent,
  //      canActivate: [AuthGuard],
  //      data: { breadcrumb: 'no-bread-crumb' },
  //    }
  //  ]
  //},
  {
    path: 'view-claim-history',
    canActivate: [AuthGuard],
    data: { breadcrumb: 'Claim History' },
    children: [
      { path: '', component: ViewClaimHistoryComponent, canActivate: [AuthGuard], data: { breadcrumb: 'no-bread-crumb' } },
      {
        canActivate: [AuthGuard],
        path: 'view-claim/:claimId',
        component: ReviewCompletedClaimDetailsComponent,
        data: { breadcrumb: 'Admin View Claim' }
      },
    ]
  },


  /*BUILD AND BUY*/
  // {
  //   path: 'build-and-buy', component: BuildAndBuyComponent, canActivate: [AuthGuard], 
  //   data: { breadcrumb: 'Build and Buy' }
  // },
  {
    path: 'build-and-buy', canActivate: [AuthGuard], data: { breadcrumb: 'Build and Buy' }, children: [

      {
        path: '', component: ProductCategoryComponent, canActivate: [AuthGuard],
        data: { breadcrumb: 'no-bread-crumb' }
      },
      {
        path: 'products/:id/:description', component: ProductComponent, canActivate: [AuthGuard],
        data: { breadcrumb: 'Products' }
      },
      {
        path: 'product-config/:id', component: ProductConfigComponent, canActivate: [AuthGuard],
        data: { breadcrumb: 'Product Config' }
      },
      {
        path: 'create-product-config/:id', component: CreateConfigurationComponent, canActivate: [AuthGuard],
        data: { breadcrumb: 'Create Config' }
      },
      {
        path: 'buildConfiguredProduct/:productId', component: BuildConfiguredProductComponent,
        canActivate: [AuthGuard], data: { breadcrumb: 'BuildConfiguredProduct' }
      },
      {
        path: 'buildKwikkeyProduct/:productCode', component: BuildKwikkeyProductComponent,
        canActivate: [AuthGuard], data: { breadcrumb: 'BuildKwikkeyProduct' }
      },

    ]
  },

  /*ORDER MANAGEMENT-manage-quote*/
  {
    path: 'manage-quote', canActivate: [AuthGuard], data: { breadcrumb: 'Manage Quote' },
    children: [
      { path: '', component: ManageQuoteComponent, canActivate: [AuthGuard], data: { breadcrumb: 'no-bread-crumb' } },
      { path: 'factory-quote request', component: FactoryQuoteRequestComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Factory Quote Request' } },
      {
        path: 'in-house-quote', component: InHouseQuotesComponent, canActivate: [AuthGuard], data: { breadcrumb: 'In-House Quote' }
      },
      {
        path: 'kawneerdirect-quotes', canActivate: [AuthGuard], data: { breadcrumb: 'KawneerDirect Quote' },
        children: [
          { path: '', component: KawneerdirectQuotesComponent, canActivate: [AuthGuard], data: { breadcrumb: 'no-bread-crumb' } },
          {
            path: 'quote-detail', component: QuoteDetailComponent,
            canActivate: [AuthGuard], data: { breadcrumb: 'Quote Detail' }
          },
          {
            path: 'quote/order-complete',//:trackerID',//required
            component: ExpressCheckoutCardPaymentCompleteComponent,
            canActivate: [AuthGuard],
            data: { breadcrumb: 'Checkout Complete' }
          },
          { path: 'editConfiguredProduct/:cartItemCommonId', component: EditConfiguredProductComponent, canActivate: [AuthGuard], data: { breadcrumb: 'EditConfiguredProduct' } },
          { path: 'copyConfiguredProduct/:cartItemCommonId', component: CopyConfiguredProductComponent, canActivate: [AuthGuard], data: { breadcrumb: 'CopyConfiguredProduct' } },
        ]
      },
      { path: 'request-quote', component: RequestQuoteComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Request Quote' } }
    ]
  },
  /*ORDER MANAGEMENT-invoice-inquiry*/
  {
    path: 'invoice-inquiry',
    canActivate: [InvoiceInquiryAuthGuard],
    data: { breadcrumb: 'Invoice Inquiry' },
    children: [
      { path: '', component: InvoiceInquiryComponent, canActivate: [AuthGuard], data: { breadcrumb: 'no-bread-crumb' } },
      {
        path: 'invoice-detail',
        component: InvoiceDetailComponent,
        canActivate: [InvoiceInquiryAuthGuard],
        data: { breadcrumb: 'Invoice Detail' }
      },
      {
        path: 'payment/review',
        component: ReviewComponent,
        //canActivate: [InvoiceInquiryAuthGuard],
        data: { breadcrumb: 'Payment Review' }
      },
      {
        path: 'payment/creditcard',
        component: PaymentCreditCardComponent,
        //canActivate: [InvoiceInquiryAuthGuard],
        data: { breadcrumb: 'Payment Credit Card' }
      }, {
        path: 'payment/pcc',
        component: PaymentCreditcardCompleteComponent,
        //canActivate: [InvoiceInquiryAuthGuard],
        data: { breadcrumb: 'Payment Credit Card Complete' }
      },
      {
        path: 'payment/redirect/review',
        component: ReviewComponent,
        //canActivate: [InvoiceInquiryAuthGuard],
        data: { breadcrumb: 'Payment Review' }
      },
      {
        path: 'payment/redirect/complete',
        component: PaymentCompleteComponent,
        //canActivate: [InvoiceInquiryAuthGuard],
        data: { breadcrumb: '' }
      },
    ]
  },
  /*ORDER MANAGEMENT-order-inquiry*/
  {
    path: 'order-inquiry', canActivate: [AuthGuard], data: { breadcrumb: 'Order Inquiry' },
    children: [
      { path: '', component: OrderInquiryComponent, canActivate: [AuthGuard], data: { breadcrumb: 'no-bread-crumb' } },
      { path: 'order-detail', component: OrderDetailComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Order Detail' } },
    ]
  },
  /*Manage Company*/
  {
    path: 'manage-address',
    component: ManageAddressComponent,
    data: { breadcrumb: 'Manage-Address' },
  },
  {
    path: 'manage-account',
    component: ManageAccountComponent,
    data: { breadcrumb: 'Manage-Account' },
    canActivate: [ManageCompanyAuthGuard]
  },

  /*SELF-SERVICE UTILITIES*/
  {
    path: 'self-service', canActivate: [AuthGuard], data: { breadcrumb: 'no-bread-crumb' }, children: [
      { path: 'credit-reference', component: CreditReferenceComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Credit Reference' } },
      { path: 'generate-warranty', component: GenerateWarrantyComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Generate Warranty' } },
      { path: 'sample-request', component: SampleRequestNewComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Sample Request' } },
      { path: 'submittal-package', component: SubmittalPackageComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Submittal Package' } },
      { path: 'lien-release', component: LienReleaseComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Lien-Release' } },
      { path: 'thermal-calculator', component: ThermalCalculatorComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Thermal Calculator' } },
      { path: 'window-pricing', component: WindowPricingComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Window Pricing Tool' } },
      {
        path: 'order-selection', canActivate: [AuthGuard], data: { breadcrumb: 'Order Selection' },
        children: [
          { path: '', component: OrderSelectionComponent, canActivate: [AuthGuard], data: { breadcrumb: 'no-bread-crumb' } },
          {
            canActivate: [AuthGuard],
            path: 'raise-claim',
            component: RaiseClaimComponent,
            data: { breadcrumb: 'Raise Claim' }
          },
        ]
      },
      { path: 'order-selection/:soNumber/raise-claim', component: RaiseClaimComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Raise Claim' } },
      { path: 'raise-claim', component: RaiseClaimComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Raise Claim' } },
      {
        path: 'claim-history', canActivate: [AuthGuard], data: { breadcrumb: 'Claim History' },
        children: [
          { path: '', component: ClaimHistoryComponent, canActivate: [AuthGuard], data: { breadcrumb: 'no-bread-crumb' } },
          {
            canActivate: [AuthGuard],
            path: 'view-claim/:claimId',
            component: ViewClaimDetailsComponent,
            data: { breadcrumb: 'View Claim' }
          },
        ]
      },
      //{ path: 'claim-history/view-claim/:claimId', component: ViewClaimDetailsComponent, canActivate: [AuthGuard], data: { breadcrumb: 'View Claim' } },

    ]
  },
  /*Custom Terms and conditions notes*/
  {
    path: 'custom-terms-conditions-notes',
    component: CustomTermsConditionsNotesComponent,
    data: { breadcrumb: 'Custom-Terms-Conditions-Notes' },
  },
  /*Product Config*/
  {
    path: 'product-config',
    component: ProductConfigComponent,
    data: { breadcrumb: 'ProductConfig' }
  },
  /*School and training*/
  {
    path: 'training', canActivate: [AuthGuard], data: { breadcrumb: 'no-bread-crumb' }, children: [
      { path: 'customer-specific-school', component: CustomerSpecificSchoolComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Customer Specific School' } },
      { path: 'mechanics-school', component: MechanicsSchoolComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Mechanics School' } },
      { path: 'modules-school', component: ModulesSchoolComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Modules School' } },
      { path: 'partner-pak-training', component: PartnerPakTrainingComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Partner Pak Training' } },
      { path: 'pre-installation-system-review', component: PreInstallationSystemReviewComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Pre Installation System Review' } },

    ]
  },
  /*Outage*/
  {
    path: 'outage',
    data: { breadcrumb: 'Outage' },
    children: [
      {
        path: '',
        component: OutageComponent,
        data: { breadcrumb: 'no-bread-crumb' },
      }
    ]
  },
  /*Lieterature */
  {
    path: 'literature', canActivate: [AuthGuard], data: { breadcrumb: 'no-bread-crumb' }, children: [
      { path: 'details-screen/:id/:description', component: DetailsScreenComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Details' } },
      { path: 'installation-instructions/details-screen/:id/:description', component: DetailsScreenComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Details' } },
      { path: 'cleaninig-aluminium/details-screen/:id/:description', component: DetailsScreenComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Details' } },
      { path: 'installation-video-curtain-wall/details-screen/:id/:description', component: DetailsScreenComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Details' } },
      { path: 'installation-video-store-front/details-screen/:id/:description', component: DetailsScreenComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Details' } },
      { path: 'order-forms/details-screen/:id/:description', component: DetailsScreenComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Details' } },
      { path: 'corrective-field-repair/details-screen/:id/:description', component: DetailsScreenComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Details' } },
      { path: 'estimating-takeoff-guide/details-screen/:id/:description', component: DetailsScreenComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Details' } },
      { path: 'certifications/literature-pages/:id', component: LieraturePagesComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Certifications' } },
      { path: 'news/literature-pages/:id', component: LieraturePagesComponent, canActivate: [AuthGuard], data: { breadcrumb: 'News' } },
      { path: 'price-catalog/literature-pages/:id', component: LieraturePagesComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Price Catalog' } },
      { path: 'estimating-takeoff-guide/literature-pages/:id', component: LieraturePagesComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Estimating Takeoff Guide' } },
      { path: 'installation-instructions/literature-pages/:id', component: LieraturePagesComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Installation Instructions' } },
      //{ path: 'details-screen/:id', component: DetailsScreenComponent, canActivate: [AuthGuard], data: { breadcrumb: 'Details' } },     
    ]
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
    data: { breadcrumb: 'unauthorized' },
  },
  {
    path: 'error',
    component: ErrorComponent,
    data: { breadcrumb: 'error' },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
